<div class="d-flex flex-column action-sheet-container">
    <div class="flex-fill" (click)="clickedOutActionSheet()"></div>
    <div class="action-sheet">
        <div class="d-flex justify-content-center align-content-center py-3">
            <div class="title" id="actionSheetTitle">{{actionSheetTitle}}</div>
            <div class="close-btn" id="actionSheetCloseBtn" (click)="clickedCloseBtnActionSheet()">
                <span class="material-icons-outlined ">cancel</span>
            </div>
        </div>
        <div>
            <ng-content></ng-content>
        </div>
    </div>
</div>